var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentErroricon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M29.1654 4.72803V13.3333C29.1654 14.5001 29.1654 15.0835 29.3924 15.5291C29.5922 15.9211 29.9109 16.2398 30.3029 16.4396C30.7485 16.6667 31.3319 16.6667 32.4987 16.6667H41.104M19.7904 24.9998L30.207 35.4165M30.207 24.9998L19.7904 35.4165M29.1654 4.1665H18.332C14.8317 4.1665 13.0815 4.1665 11.7446 4.84771C10.5686 5.44692 9.61245 6.40305 9.01324 7.57906C8.33203 8.91601 8.33203 10.6662 8.33203 14.1665V35.8332C8.33203 39.3335 8.33203 41.0837 9.01324 42.4206C9.61245 43.5966 10.5686 44.5528 11.7446 45.152C13.0815 45.8332 14.8317 45.8332 18.332 45.8332H31.6654C35.1657 45.8332 36.9159 45.8332 38.2528 45.152C39.4288 44.5528 40.3849 43.5966 40.9842 42.4206C41.6654 41.0837 41.6654 39.3335 41.6654 35.8332V16.6665L29.1654 4.1665Z",
    stroke: "#F26648",
    strokeWidth: 4.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentErroricon);
export default __webpack_public_path__ + "static/media/document--error.icon.b2a8b67184b52bb4cd348a0785c6a78b.svg";
export { ForwardRef as ReactComponent };